import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  addIcon: {
    color: theme.palette.colors.white,
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/RealEstateAgentsList/components/RealEstateAgentCard/components/ActionComponent/useStyles.js